'use client';

import { useEffect, useRef, useState } from 'react';

interface RichDescriptionProps {
  /** HTML d'un champ `rich_text` (ex. description de prestation), assaini à l'écriture par le backend. */
  html: string;
  labels: { read_more: string; read_less: string };
}

/**
 * Description rich text d'une prestation (tunnel classique ET tunnel VTC) : le HTML du pro est
 * RENDU — jamais affiché en texte brut. Tronquée à 3 lignes par défaut ; le bouton « Lire la
 * suite » n'apparaît que si le contenu déborde réellement.
 */
export function RichDescription({ html, labels }: RichDescriptionProps) {
  const descriptionRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);

  useEffect((): void => {
    if (expanded) return;
    const el = descriptionRef.current;
    if (!el) return;
    setOverflows(el.scrollHeight > el.clientHeight + 1);
  }, [expanded, html]);

  return (
    <div className="bt-service-card__description-wrap">
      <div
        ref={descriptionRef}
        className={`bt-service-card__description ${expanded ? '' : 'bt-service-card__description--clamped'}`}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      {(overflows || expanded) && (
        <button
          type="button"
          className="bt-service-card__desc-toggle"
          onClick={(): void => setExpanded((v): boolean => !v)}
        >
          {expanded ? labels.read_less : labels.read_more}
        </button>
      )}
    </div>
  );
}
